import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 219px)',
      overflowY: 'scroll',
    },
    card: {
      padding: '12px',
    },
    searchBarOuterGrid: {
      alignSelf: 'center',
      display: 'flex',
    },
    xFeatherGrid: {
      alignSelf: 'center',
      marginLeft: '16px',
      display: 'flex',
    },
    searchBarDividerGrid: {
      marginLeft: 16,
      marginRight: 16,
      alignSelf: 'center',
      height: 32,
    },
    greenDot: {
      height: '5px',
      width: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      backgroundColor: '#2AAB3F',
      margin: '0px 12px 4px 12px',
    },
    quickFilterText: {
      display: 'inline-block',
      textAlign: 'right',
    },
    ToggleButton: {
      '&.MuiToggleButton-root.Mui-selected': {
        backgroundColor: 'rgba(42, 171, 63, 1)',
      },
    },
    labelColor: {
      color: 'none',
    },
    locationButtonGrid: {
      display: 'flex',
      flexFlow: 'wrap',
    },
    dividerGrid: {
      '& > hr ': {
        backgroundColor: '#E0E0E0',
      },
    },
    divider: {
      width: '100%',
      margin: '8px 0px',
    },
    orgNameLabelGrid: {
      '& > p': {
        fontSize: '14px',
        letterSpacing: '0.25px',
      },
    },
    nameLabel: {
      paddingTop: '4px',
    },
    outerGridOfDialog: {
      padding: '6px 0px',
      maxHeight: 200,
      overflowY: 'auto',
    },
    infoFeather: {
      stroke: '#93C7EB',
      width: '16px',
      height: '16px',
      marginRight: '5px',
      marginTop: '12px',
    },
    plusIcon: {
      marginRight: 9.67,
      height: 20,
      width: 20,
      cursor: 'pointer',
    },
    circularLoader: {
      marginLeft: '45%',
    },
    addInspButtonContainer: {
      paddingTop: 8,
      paddingBottom: 16,
      '& button': {
        width: 'fit-content',
        height: 32,
      },
      '& .plusCircle': {
        marginRight: 9.67,
        height: 16.67,
        width: 16.67,
      },
    },
    toggleGrid: {
      paddingTop: 8,
    },
    spGrid: {
      marginTop: 24,
    },
    spSelect: {
      width: '100%',
      height: 44,
      color: 'white',
    },
    autoCompleteGrid: {
      alignSelf: 'center',
      marginTop: 24,
    },
    autoComplete: {
      width: '100%',
      paddingBottom: '24px',
    },
    searchIcon: {
      width: 20,
      height: 20,
    },
  }),
);

export default useStyles;
